var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTapGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "#0044c6"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6071 4.5C9.58107 4.5 8.75 5.32919 8.75 6.35294V7.27941H21.75V6.35294C21.75 5.32919 20.9189 4.5 19.8929 4.5H10.6071ZM8.75 9.13235V12.8382C8.75 13.2403 8.88181 13.6092 9.10003 13.9131L13.3094 11.2965C14.1154 10.7953 15.171 10.9805 15.756 11.7272L16.4325 12.5921C16.9098 13.2018 17.1277 13.95 17.0999 14.6912H19.8929C20.9189 14.6912 21.75 13.862 21.75 12.8382V9.13235H8.75ZM5.73033 9.2174C5.53189 9.2259 5.32908 9.28859 5.14453 9.41645L3.04799 10.8713C2.54842 11.2169 2.25 11.7844 2.25 12.3913V18.3971C2.25 19.4208 3.08107 20.25 4.10714 20.25H9.29046C10.3305 20.25 11.3018 19.731 11.8785 18.8675L14.9997 15.3625C15.3544 14.8733 15.3422 14.2092 14.9689 13.7339C14.5557 13.1067 14.0308 13.0029 13.3929 13.4281L9.31041 15.9669C8.25741 16.6219 6.89286 15.8656 6.89286 14.6278V10.3284C6.89286 9.65652 6.32564 9.19191 5.73033 9.2174Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapGo);
export default __webpack_public_path__ + "static/media/Tap & Go.6dc23781851ac57660a0d6cf92d0c93a.svg";
export { ForwardRef as ReactComponent };